// extracted by mini-css-extract-plugin
export default {"island":"style_island__Sk4K4","header":"style_header__JeoG8"};